import { render, staticRenderFns } from "./NewMatches.vue?vue&type=template&id=60204139&scoped=true&"
import script from "./NewMatches.vue?vue&type=script&setup=true&lang=js&"
export * from "./NewMatches.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60204139",
  null
  
)

export default component.exports